import { render } from "./settingsprofile.vue?vue&type=template&id=95142f22"
import script from "./settingsprofile.vue?vue&type=script&lang=js"
export * from "./settingsprofile.vue?vue&type=script&lang=js"

import "./settingsprofile.vue?vue&type=style&index=0&id=95142f22&lang=css"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__